module.exports = __webpack_public_path__ + "static/media/Noplan.a929f4c1.png";